// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"4c6a3125","111":"ba30d79c","359":"318e7025","394":"0ad69b6d","549":"9f9ac063","705":"bd027628","726":"62cb781b"}[chunkId] + ".chunk.js";
};